module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ixf6r"))).then(() => parcelRequire('9Lwss'));